import { render, staticRenderFns } from "./ClientAdd.vue?vue&type=template&id=60f442e8&"
import script from "./ClientAdd.vue?vue&type=script&lang=ts&"
export * from "./ClientAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f442e8')) {
      api.createRecord('60f442e8', component.options)
    } else {
      api.reload('60f442e8', component.options)
    }
    module.hot.accept("./ClientAdd.vue?vue&type=template&id=60f442e8&", function () {
      api.rerender('60f442e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/ClientAdd.vue"
export default component.exports